"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("src/environments/environment");
var WickedApiClient_1 = require("../api/WickedApiClient");
var FileInfo = /** @class */ (function (_super) {
    __extends(FileInfo, _super);
    function FileInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.progressPercentage = 0;
        _this.loaded = 0;
        _this.isUploading = false;
        _this.uploaded = true;
        return _this;
    }
    FileInfo.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.imageUrl = environment_1.environment.apiBaseUrl + "/FileGet/" + this.fileName;
        }
    };
    FileInfo.fromJS = function (data) {
        data = typeof data === "object" ? data : {};
        var result = new FileInfo();
        result.init(data);
        return result;
    };
    FileInfo.prototype.toJSON = function (data) {
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return FileInfo;
}(WickedApiClient_1.DTOAdvertisementImage));
exports.FileInfo = FileInfo;
